// @ts-nocheck
import { ShellContext } from "@insite/client-framework/Components/IsInShell";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getWidgetsByIdAndZone } from "@insite/client-framework/Store/Data/Widgets/WidgetSelectors";
import { useContext } from "react";
import { shallowEqual } from "react-redux";
import { useSelector } from "react-redux";

const useZoneWidgets = (contentId: string, zoneName: string) => {
    const shellContext = useContext(ShellContext);

    return useSelector((state: ApplicationState) => {
        const pageId = shellContext.pageId || getCurrentPage(state).id;

        return getWidgetsByIdAndZone(state, contentId, zoneName, pageId);
    }, shallowEqual);
};

export default useZoneWidgets;
